import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["article", "tab", "searchInput", "noResults"]

  connect() {
    this.activeCategory = "All"
    this.searchQuery = ""
  }

  changeTab(event) {
    const category = event.currentTarget.dataset.category
    this.activeCategory = category

    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.category === category) {
        tab.classList.remove("bg-slate-100", "text-slate-600", "hover:bg-slate-200")
        tab.classList.add("bg-blue-600", "text-white", "shadow-lg")
      } else {
        tab.classList.add("bg-slate-100", "text-slate-600", "hover:bg-slate-200")
        tab.classList.remove("bg-blue-600", "text-white", "shadow-lg")
      }
    })

    this.filter()
  }

  search(event) {
    this.searchQuery = event.target.value.toLowerCase()
    this.filter()
  }

  filter() {
    let visibleCount = 0

    this.articleTargets.forEach(article => {
      const category = article.dataset.category
      const title = (article.dataset.title || "").toLowerCase()
      const content = (article.dataset.content || "").toLowerCase()

      const matchesCategory = this.activeCategory === "All" || category === this.activeCategory
      const matchesSearch = title.includes(this.searchQuery) || content.includes(this.searchQuery)

      if (matchesCategory && matchesSearch) {
        article.classList.remove("hidden")
        visibleCount++
      } else {
        article.classList.add("hidden")
      }
    })

    if (visibleCount === 0) {
      if (this.hasNoResultsTarget) this.noResultsTarget.classList.remove("hidden")
    } else {
      if (this.hasNoResultsTarget) this.noResultsTarget.classList.add("hidden")
    }
  }

  clearFilters() {
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
    }
    this.searchQuery = ""

    // Reset to "All" tab
    const allTab = this.tabTargets.find(tab => tab.dataset.category === "All")
    if (allTab) {
      this.changeTab({ currentTarget: allTab })
    } else {
      this.activeCategory = "All"
      this.filter()
    }
  }
}
